module.exports = __webpack_public_path__ + "img/placeholder.6d1fd1d6.png";